import { Component, Input } from '@angular/core';
import { IconType } from '@shared/utils/icons';

@Component({
  selector: 'shared-ui-icons-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.css'],
  standalone: false,
})
export class IconComponent {
  @Input() public iconName: IconType = IconType.None;
  @Input() public tooltip = '';
  @Input() public iconSize = '1rem';
  @Input() public iconClass = '';
  public IconType = IconType;

  constructor() {}
}
